interface ClinicalSummaryGeneratingShimmerProps {
  active: boolean
}

/**
 * Sweep over the whole summary field while phenotypes generate. Mount it after the textarea: it
 * tints the text it passes over without taking pointer events, so typing carries on underneath.
 */
export function ClinicalSummaryGeneratingShimmer({ active }: ClinicalSummaryGeneratingShimmerProps) {
  if (!active) return null

  return (
    <div
      data-testid="clinical-summary-generating-shimmer"
      className="clinical-summary-shimmer pointer-events-none absolute inset-0 z-[2] rounded-base"
      aria-hidden="true"
    />
  )
}
